import TableCellDateFin from '../../Components/Includes/Table/TableCellDateFin'

export const fin = {
  id: "fin",
  sort: true,
  padding: true,
  label: "Fin",
  component: TableCellDateFin
}
